import type { U3141ChildLotChain } from '../U3141Service';

export type U3141GraphEditConcordanceSnapshot = {
  concordance: string[];
  concordancePartieDeLot?: boolean[];
};

/** Capture concordances à l’ouverture du dialogue édition graphe (BL-0662). */
export function u3141CaptureConcordanceSnapshot(child: U3141ChildLotChain): U3141GraphEditConcordanceSnapshot {
  const ld = child.lotDetail;
  const snapshot: U3141GraphEditConcordanceSnapshot = {
    concordance: [...(ld?.concordance ?? [])],
  };
  if (ld?.concordancePartieDeLot != null) {
    snapshot.concordancePartieDeLot = [...ld.concordancePartieDeLot];
  }
  return snapshot;
}

/** Réinjecte le snapshot concordance avant POST update (liste inchangée côté graphe). */
export function u3141ApplyConcordanceSnapshotForGraphEdit(
  child: U3141ChildLotChain,
  snapshot: U3141GraphEditConcordanceSnapshot,
): U3141ChildLotChain {
  if (!child.lotDetail) {
    return child;
  }
  const nextDetail = {
    ...child.lotDetail,
    concordance: [...snapshot.concordance],
  };
  if (snapshot.concordancePartieDeLot !== undefined) {
    nextDetail.concordancePartieDeLot = [...snapshot.concordancePartieDeLot];
  }
  return {
    ...child,
    lotDetail: nextDetail,
  };
}
